import { types } from "../types/types";

export const setLoginErr = (payload) => ({
  type: types.setLoginErr,
  payload,
});
